import React from "react";

interface VialTypes {
    label: string;
    amount: string;
    width: number;
    height: number;
    paddingTop?: number;
}

export const VialSvg = ({ label, amount, width=600, height=600, paddingTop = 20 }: VialTypes) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 1200 1200"
      aria-labelledby="vialTitle vialDesc"
      role="img"
    >
      <title id="vialTitle">Vial Diagram</title>
      <desc id="vialDesc">
        A diagram of a pharmaceutical vial showing key sections with a dynamic
        label.
      </desc>

      {/* Outer Vial Body */}
      <path
        d="M856.44 356.64c-3.84-17.039-24.719-30.961-55.68-41.762 
          31.68-11.039 52.922-25.32 56.281-42.84v-143.16h-.96C846.235 83.999 
          720 59.999 600 59.999s-246.24 24-256.44 68.52h-.962l.004 138.72a21.64 
          21.64 0 0 0 0 3.96v.84c3.36 17.52 24.602 31.802 56.281 42.84-30.961 
          10.802-51.719 24.72-55.68 41.763h-.96l-.005 658.2a18.617 18.617 0 0 
          0 0 2.64c.363 68.641 113.76 122.52 257.76 122.52 142.08 0 253.92-52.199 
          257.4-119.28v-664.08z"
        fill="#E0E0E0"
        stroke="#000"
        strokeWidth="5"
      />

      {/* Top of the Vial */}
      <path
        d="M600 76.56c149.16 0 240.84 33.719 240.84 57.719 
          0 24.004-91.68 57.723-240.84 57.723S359.16 158.4 
          359.16 134.283c0-24.121 91.68-57.723 240.84-57.723z"
        fill="#BDBDBD"
        stroke="#000"
        strokeWidth="3"
      />

      {/* Taller Middle Band */}
      <path
        d="M429.24 562.84h341.4v174.04h-341.4z"
        fill="white"
        stroke="#000"
        strokeWidth="4"
      />
      {/* Label Text with Padding */}
      <text
        x="600"
        y={610 + paddingTop}
        textAnchor="middle"
        fontSize="48"
        fontWeight="bold"
        fontFamily="sans-serif"
        fill="#000"
      >
        {label}
      </text>
      <text
        x="600"
        y={670 + paddingTop}
        textAnchor="middle"
        fontSize="40"
        fontWeight="normal"
        fontFamily="sans-serif"
        fill="#000"
      >
        {amount}
      </text>

      {/* Vial Content */}
      <path
        d="M704.16 134.28c0 15.242-46.633 27.598-104.16 27.598s-104.16-12.355-104.16-27.598
          c0-15.246 46.633-27.602 104.16-27.602s104.16 12.355 104.16 27.602"
        fill="#81D4FA"
        stroke="#000"
        strokeWidth="3"
      />

      {/* Bottom Curve */}
      <path
        d="M359.16 267.24a14.773 14.773 0 0 1 0-2.277l1.078-9.48h-1.32l.004-93.72c39.359 
          30.238 142.56 46.918 241.08 46.918s201.6-16.68 240.84-46.918v93.72h-1.68l1.441 
          9.48c.059.758.059 1.52 0 2.277 0 24-91.68 57.602-240.84 57.602s-240.6-33.48-240.6-57.602z"
        fill="#BDBDBD"
        stroke="#000"
        strokeWidth="3"
      />
    </svg>
  );
};